export default __webpack_public_path__ + "static/media/SPORTHECA.406ed17e.png";